export default __webpack_public_path__ + "static/media/bp-diaries.7bc04b6c.gif";